import { z } from '../zod.js';
import { SubscriptionToolDataValidationSchema } from '../subscription/response';

export const CancelSubscriptionGuidanceValidationSchema = z.object({
  requiresDashboardAction: z.literal(true).meta({
    description:
      'Always `true`. Signals that this tool only surfaces context — the cancellation itself must be performed in the Checkout Page dashboard, at `data.dashboardUrl`.',
  }),
  eligible: z.boolean().meta({
    description:
      'Whether the subscription is in a state where cancellation can proceed. `false` for already-canceled or expired subscriptions.',
  }),
  blockedReason: z.string().optional().meta({
    description:
      'Human-readable explanation of why the subscription cannot be canceled, when `eligible` is `false`.',
  }),
  sideEffects: z.array(z.string()).optional().meta({
    description:
      'Plain-language list of consequences the human should know before performing the cancellation. Omitted when `eligible` is `false` — no action is offered so no side effects apply.',
  }),
  options: z
    .object({
      timing: z.array(z.enum(['immediately', 'at_period_end', 'custom_date'])).meta({
        description:
          'Available cancellation timing choices in the dashboard. Fixed-term subscriptions (`planIterations > 0`) only support `immediately`.',
      }),
      currentPeriodEnd: z.iso.datetime().nullable().meta({
        description:
          'End of the current billing period. If the user chooses `at_period_end` timing, the subscription ends at this date. May be `null` for subscriptions that never activated.',
      }),
    })
    .optional()
    .meta({
      description:
        'Cancellation options the user can choose from in the dashboard. Omitted when `eligible` is `false`. The full subscription record on `data` still includes `currentPeriodEnd` regardless of eligibility.',
    }),
});

export const CancelSubscriptionResponseValidationSchema = z.object({
  data: SubscriptionToolDataValidationSchema,
  guidance: CancelSubscriptionGuidanceValidationSchema,
});
